export enum XpoGridDisplayDensityOptions {
  Default = 'Default',
  Compact = 'Compact',
  Comfortable = 'Comfortable',
}
